
<ng-template #staticDataModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">{{ title }}</h5>
        <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"
            aria-hidden="true"></button>
    </div>
    <div class="modal-body">
        <p>{{ text }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light"
            (click)="modal.close('Close click')">Cancelar</button>
        <button (click)="confirm()" type="button" class="btn btn-danger">Excluir</button>
    </div>
</ng-template>